const chip = {
  root: {
    borderRadius: '{spacing.xxs}',
    paddingX: '{spacing.xs}',
    paddingY: '{spacing.xs}',
    gap: '{sizes.xs}',
    transitionDuration: '{transition.duration}',
    height: '32px',
  },
  image: {
    width: '{sizes.l}',
    height: '{sizes.l}',
  },
  icon: {
    size: '{sizes.m}',
  },
  removeIcon: {
    size: '{sizes.xs}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '0',
      shadow: '{form.field.focus.ring.shadow}',
    },
  },
  colorScheme: {
    light: {
      root: {
        background: '{grayScale.200}',
      },
    },
    dark: {
      root: {
        background: '{grayScale.200}',
      },
    },
  },
};

export default chip;
